import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import Feature from 'ol/Feature';

import { Icon, Stroke, Style } from 'ol/style';

import { BingMaps, XYZ } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import * as olProj from 'ol/proj';

import { LineString, MultiPoint, Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import axios1 from 'axios';

import { Text, Fill } from 'ol/style';

import * as XLSX from 'xlsx';

import { MapService } from 'src/app/Service/map.service';

declare let $: any;

interface ITrip {
  tiTripReason: number;

  tiConfirmationLevel: number;

  strComment: string;
}

interface IMobileType {
  tiMobileType: number;

  strComment: string;
}

@Component({
  selector: 'app-search-trips',

  templateUrl: './search-trips.component.html',

  styleUrls: ['./search-trips.component.css'],
})
export class SearchTripsComponent implements OnInit {
  lst_TripReason: ITrip[] = [];

  lst_MobileType: IMobileType[] = [];

  lst_Domain: any[] = [];

  lst_TripStatus: any[] = [];

  lst_UserManager = [];

  list_Trips = [];

  list_Trips_Search = [];

  tabNumber: number = 0;

  trip_Obj: any = {};

  source: any;

  vector: any;

  layers: any = [];

  map: any;

  vectorLayer: any;

  searchModel: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(localStorage.getItem('ID')!),
    ),

    strSession: new FormControl(
      this.gurdService.decrypt(localStorage.getItem('Session')!),
    ),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    tiAppUsage: new FormControl('1'),

    tiTripStatus: new FormControl('-1'),

    tiTripReason: new FormControl('-1'),

    tiMobileType: new FormControl('-1'),

    strChart: new FormControl(''),

    iMobileDomain: new FormControl('-1'),

    tiTripType: new FormControl('-1'),
  });

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(
    private location: Location,

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _mapService: MapService,
  ) {}

  ngOnInit(): void {
    this.getTripReasons();

    this.getVehicleTypes();

    this.getDomain();

    this.getTripStatus();

    this.getUserManager();
  }

  async getTripReasons() {
    let res = JSON.parse(
      (await axios.post(`TripReason_List`, {})).data.toString(),
    );

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_TripReason = res;
  }

  async getVehicleTypes() {
    let res = JSON.parse(
      (await axios.post(`MobileType_List`, {})).data.toString(),
    );

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_MobileType = res;
  }

  async getDomain() {
    const model = this._otherService.stringNumberToNumber(
      this.searchModel.value,
    );
    let res = JSON.parse(
      (await axios.post(`MobileDomain_List`, model)).data.toString(),
    );

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_Domain = res;
  }

  async getTripStatus() {
    const model = this._otherService.stringNumberToNumber(
      this.searchModel.value,
    );
    let res = JSON.parse(
      (await axios.post(`TripStatus_List`, model)).data.toString(),
    );

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_TripStatus = res;
  }

  async getUserManager() {
    const model = this._otherService.stringNumberToNumber(
      this.searchModel.value,
    );
    let res = JSON.parse(
      (await axios.post(`UserManager_Chart_List`, model)).data.toString(),
    );

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_UserManager = res;
  }

  isSelected(tiType: number) {
    if (tiType == -1) return true;

    return false;
  }

  chooseTiType(tiType: number) {
    this.searchModel.get('tiTripType')?.setValue(tiType);
  }

  async searchTrip() {
    this._otherService.Showspinner();

    let res = JSON.parse(
      (
        await axios.post(
          `OffitialTrip_Search`,
          this._otherService.stringNumberToNumber(this.searchModel.value),
        )
      ).data.toString(),
    );

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_Trips = res;

    this.list_Trips_Search = res;
  }

  filter_list(val: any) {
    this.list_Trips = this.list_Trips_Search.filter((el: any) => {
      return (
        el.strFullName.includes(val.value) ||
        el.strPassengersName.includes(val.value) ||
        el.strTripReason_strComment.includes(val.value) ||
        el.iOfficialTrip.toString().includes(val.value) ||
        el.strTripImportance_strComment.toString().includes(val.value) ||
        el.strMobileType_strComment.includes(val.value) ||
        el.strDestinationAddress.includes(val.value) ||
        el.strSourceAddress.includes(val.value)
      );
    });

    if (val.value.trim() == '') {
      this.list_Trips = this.list_Trips_Search;
    }
  }

  highlightText(text: string, searchTerm: string) {
    if (!searchTerm) {
      return text;
    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {
      return `<mark>${match}</mark>`;
    });
  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'سفرهای اداری.xlsx');
  }

  showTripRoute(item: any) {
    window.open(`route/${item.strUnitID}`, '_blank');

    window.localStorage.setItem(
      'RouteDate',
      this.gurdService.encrypt(item.strTripStartDate),
    );

    window.localStorage.setItem(
      'reportStime',
      this.gurdService.encrypt(item.strTrimpStartTime),
    );

    window.localStorage.setItem(
      'reportEtime',
      this.gurdService.encrypt(item.strTrimpFinishTime),
    );

    window.localStorage.setItem(
      'UnitID',
      this.gurdService.encrypt(item.strUnitID.toString()),
    );

    window.localStorage.setItem(
      'carName',
      this.gurdService.encrypt(item.strFullName.toString()),
    );

    window.localStorage.setItem(
      'plate',
      this.gurdService.encrypt(item.strVehicleNo.toString()),
    );
  }

  fitMap(data?: any) {
    // if (data == null) {
    //   data = this.fullRoute;
    // }
    // if (data.length > 1) {
    //   var maxLatitude = Math.max.apply(
    //     Math,
    //     data.map(function (o: any) {
    //       return o.fLat;
    //     })
    //   );
    //   var maxLongitude = Math.max.apply(
    //     Math,
    //     data.map(function (o: any) {
    //       return o.fLon;
    //     })
    //   );
    //   var minLatitude = Math.min.apply(
    //     Math,
    //     data.map(function (o: any) {
    //       return o.fLat;
    //     })
    //   );
    //   var minLongitude = Math.min.apply(
    //     Math,
    //     data.map(function (o: any) {
    //       return o.fLon;
    //     })
    //   );
    //   var view = this.map.getView();
    //   var transformedStart = this.mapService.transformCoordinates2([
    //     maxLongitude,
    //     maxLatitude,
    //   ]);
    //   var transformedEnd = this.mapService.transformCoordinates2([
    //     minLongitude,
    //     minLatitude,
    //   ]);
    //   var source = [
    //     Math.min(transformedStart[0], transformedEnd[0]) - 2000,
    //     Math.min(transformedStart[1], transformedEnd[1]) - 2000,
    //     Math.max(transformedStart[0], transformedEnd[0]) + 2000,
    //     Math.max(transformedStart[1], transformedEnd[1]) + 2000,
    //   ];
    //   view.fit(source);
    // }
  }

  openViewModal(item: any, isResult?: boolean) {
    if (isResult) {
      this.tabNumber = 1;

      setTimeout(async () => {
        this.showRouteOnMap(item);
      }, 500);
    } else {
      this.tabNumber = 0;

      this.trip_Obj = item;

      $('#viewModal').modal('show');

      // setTimeout(async () => {

      //   this.showRouteOnMap(item)

      // }, 500);
    }
  }

  showRouteOnMap = async (item: any) => {
    var model = this._otherService.stringNumberToNumber({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

      strSDate: item.strTripStartDate,

      strEDate: item.strTripStartDate,

      strSTime: item.strTrimpStartTime,

      strETime: item.strTrimpFinishTime,
    });

    if (this.map) {
      this.map.setTarget(null);
    }

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({
      source: this.source,
    });

    if (this.bOfflineMap) {
      this.layers.push(
        new TileLayer({
          source: new XYZ({
            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr', //
          }),
        }),
      );
    } else {
      const styles = ['AerialWithLabelsOnDemand'];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {
        this.layers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],
            }),
          }),
        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector);
    }

    // رسم مسیر پیشنهادی

    this.map = new Map({
      target: 'mapContainer',

      layers: this.layers,

      view: new View({
        center: olProj.fromLonLat([item.fsLon, item.fsLat]),

        zoom: 14,
      }),
    });

    const startCoords = olProj.fromLonLat([item.fsLon, item.fsLat]);

    const destinationCoords = olProj.fromLonLat([item.fDLon, item.fDLat]);

    const startFeature = new Feature({
      geometry: new Point(startCoords),
    });

    const destFeature = new Feature({
      geometry: new Point(destinationCoords),
    });

    const startIcon = new Icon({
      src: '../../assets/Img/marker4.png',

      size: [48, 48],
    });

    const destIcon = new Icon({
      src: '../../assets/Img/marker5.png',

      size: [48, 48],
    });

    startFeature.setStyle(
      new Style({
        image: startIcon,
        text: new Text({
          text: 'مبدأ', // Replace with desired text

          offsetY: -30, // Adjust the vertical position

          font: '16px Vazir', // Set the font style

          fill: new Fill({ color: 'Green' }), // Set the text color

          stroke: new Stroke({ color: 'blue', width: 1 }),
        }),
      }),
    );

    destFeature.setStyle(
      new Style({
        image: destIcon,
        text: new Text({
          text: 'مقصد', // Replace with desired text

          offsetY: -30, // Adjust the vertical position

          font: '16px Vazir', // Set the font style

          fill: new Fill({ color: 'Red' }), // Set the text color

          stroke: new Stroke({ color: 'blue', width: 1 }),
        }),
      }),
    );

    this._otherService.Showspinner();

    const api = 'https://api.openrouteservice.org/v2/directions/driving-car';

    const apiKey = '5b3ce3597851110001cf6248f929f5c0617b429ba92f0e10df39ced9';

    const apiUrl = `${api}?api_key=${apiKey}&start=${item.fsLon},${item.fsLat}&end=${item.fDLon},${item.fDLat}`;

    axios1
      .get(apiUrl)
      .then((response) => {
        const routeCoordinates = response.data.features[0].geometry.coordinates;

        const transformedRouteCoordinates = routeCoordinates.map((coord: any) =>
          olProj.fromLonLat([coord[0], coord[1]]),
        );

        const routeGeometry = new LineString(transformedRouteCoordinates);

        const routeFeature = new Feature({
          geometry: routeGeometry,
        });

        const routeStyle = new Style({
          stroke: new Stroke({
            color: 'green',

            width: 3,

            lineDash: [6, 6],
          }),
        });

        routeFeature.setStyle(routeStyle);

        const vectorSource = new VectorSource({
          features: [startFeature, destFeature, routeFeature],
        });

        this.vectorLayer = new VectorLayer({
          source: vectorSource,
        });

        this.map.addLayer(this.vectorLayer);

        const iconCoordinates = [startCoords, destinationCoords];

        const boundingBox = new LineString(iconCoordinates).getExtent();

        this.map.getView().fit(boundingBox, { padding: [50, 50, 50, 50] });
      })
      .catch((error) => {
        console.error('Error fetching route:', error);
      });

    // رسم مسیر طی شده توسط راننده

    let res = (await axios.post(`GetAllMobileHistory`, model)).data;

    this._otherService.nonespinner();

    if (!res.length) return;

    this._mapService.drawRouteFull('fullRoute', this.map, res, 'Hello');
  };
}
